module.exports = __webpack_public_path__ + "media/graduate_students/cap-42c6a448.png";